/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';
import {Function} from './function';

export class TagDefinition extends BaseEntity {
  category: string;
  type: string;
  owner: string;
  functions: Function[];
}
